// extracted by mini-css-extract-plugin
module.exports = {"label":"TelemetryPage_label__3u2qa"};